import './Snackbar.scss';

import React from 'react';

import TRANSLATIONS from './translations@default.json';

export const BasketSnackbar = () => {
	return (
		<div className="basket-snackbar bg-water text-white p-4 w-full rounded">
			<div className="flex justify-between">
				<div className="flex">
					<div className="flex items-center">
						<span
							className="ico ico-2x ico-basket"
							role="img"
							aria-label="Basket Logo"></span>
					</div>
					<div className="pl-3 pr-3">
						<p className="text-body font-bold text-white">
							{TRANSLATIONS.greatChoice}
						</p>
						<p className="text-body-xs text-white">
							{TRANSLATIONS.inYourBasket}
						</p>
					</div>
				</div>
				<div className="flex justify-center items-center">
					<a
						href={`${window.checkoutUrlPrefix}/shoppingbasket.aspx`}
						className="cta cta-secondary btn btn-secondary text-white border-white text-center"
						data-tag-name="view-basket-button-snackbar"
						data-testid="view-basket-button">
						{TRANSLATIONS.view}
					</a>
				</div>
			</div>
		</div>
	);
};

export default BasketSnackbar;
